

























































import { Vue, Prop, Component } from "vue-property-decorator";
import ListenersInRequestListItem from "@/components/orders/ListenersInRequestListItem.vue";
import { User as IUser } from "@/api/models/user";
import CustomTable from "@/components/form/CustomTable.vue";
import CField from "@/components/form/CField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import { usersFilter, IUserFilter } from "@/utils/filter-listeners";

@Component({
  components: {
    CustomDatepicker,
    CustomTableCol,
    CustomTableItem,
    CustomButton,
    CField,
    CustomTable,
    ListenersInRequestListItem
  }
})
export default class ListenerInRequestList extends Vue {
  @Prop() users!: Array<IUser>;
  @Prop() listenersIds!: Array<string>;
  @Prop() courseId!: string;
  userRegisteredAtMin!: Date | undefined;
  userRegisteredAtMax!: Date | undefined;
  searchListenerByEmail: string = "";

  data() {
    return {
      userRegisteredAtMin: undefined,
      userRegisteredAtMax: undefined
    };
  }

  get filteredUsers() {
    const params: IUserFilter = {
      email: this.searchListenerByEmail,
      fullName: this.searchListenerByEmail,
      registeredAtMin: this.userRegisteredAtMin,
      registeredAtMax: this.userRegisteredAtMax
    };
    return usersFilter(this.users, params);
  }

  clearFilter() {
    this.userRegisteredAtMin = undefined;
    this.userRegisteredAtMax = undefined;
    this.searchListenerByEmail = "";
  }
}
